<template functional>
  <div
    :class="[data.class, data.staticClass]"
    :style="{ backgroundImage: `url('${require('@/assets/images/sections/auth.jpg')}')` }"
    class="CenteredCardLayout bg-cover bg-no-repeat"
  >
    <div class="content-holder lg:p-l min-h-screen flex">
      <div class="container p-0 flex lg:p-l items-center w-full">
        <div class="w-full flex h-full md:rounded overflow-hidden shadow-md bg-white relative">
          <slot/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * @module CenteredCardLayout
 */
export default {
  name: 'CenteredCardLayout'
}
</script>

<style lang='scss'>
@import '~utils';

</style>
